import styled from 'styled-components';

export const ReportSectionList = styled.div`
  > label {
    padding: 21px 10px;
    height: 60px;

    > span {
      font-size: 15px;
    }

    &::after {
      height: 0;
    }
  }
`;
